import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export class GetContactTokenUserService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {GetContactTokenUserErrorFactory} deps.getContactTokenUserErrorFactory
   * @param {SessionStorageUserRepository} deps.userRepository
   */
  constructor({getContactTokenUserErrorFactory, userRepository}) {
    super()

    this._userRepository = userRepository
    this._getContactTokenUserErrorFactory = getContactTokenUserErrorFactory
  }

  /**
   * @return {Promise<ContactTokenValueObject, Error>} returns Promise with Contact Token Value Object or Error
   */
  @inlineError
  async execute() {
    const [error, response] = await this._userRepository.getContactToken()

    if (error) {
      throw this._getContactTokenUserErrorFactory()
    }

    return response
  }
}
